import {writable} from '@convincely/components/src/library.js';
import {DataItems} from '@convincely/components/src/components/Item/DataItems.js';
import {conf} from '@convincely/utils/lib/services/conf.js';
import {reusable} from '@convincely/utils/lib/services/convincely.js';
import {coreInput} from '@convincely/utils/lib/services/input.js';
import {createCookieStorage, createSessionStorage, createStorage, DataStorage} from '@convincely/utils/lib/services/storage.js';
import {getInputStore} from '@convincely/components/src/components/Item/InputItem.js';

export const countriesStore = new DataItems();
export const phoneNumberFullStore = getInputStore('phoneNumberFull');
export const phoneNumberCode = getInputStore('phoneNumberCode');
export const errorStore = getInputStore('apiErrors');
export const refreshStore = writable({});

const contexts = {
  core: coreInput,
};

const contextTypes = {
  main: createStorage,
  cookie: createCookieStorage,
  sensitive: () => new DataStorage(),
  session: createSessionStorage,
};

/**
 * @param {string} [name]
 * @param {string} [type]
 * @return {import('@convincely/core-export/src/services/storage').DataStorage}
 */
export function getInputContext(name = 'core', type = 'main') {
  if (!contexts[name]) {
    contexts[name] = reusable(`input_${name}`, (contextTypes[type] || createStorage)(name), conf.$appName);
  }

  return contexts[name];
}
